export default {
  delete: ({ DELETE }, idProduit) =>
    new Promise((resolve, reject) => {
      if (!idProduit) {
        reject(new Error(`Erreur paramètre : idProduit non valide "${idProduit}"`))
      }
      return DELETE(`production/produits/${idProduit}`)
        .then(reponse => {
          const data = reponse.data
          if ([200, 204].includes(reponse.status)) {
            resolve(data)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
}
